import PageManipulationControlsContainer from './PageManipulationControlsContainer';

export default PageManipulationControlsContainer;